module.exports = __webpack_public_path__ + "img/image-boxes.e8f69651.svg";